import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue2Filters from 'vue2-filters';
import { ObserveVisibility } from 'vue-observe-visibility';

import './registerServiceWorker';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import "@/scss/app.scss";

Vue.config.productionTip = false;

Vue.directive('observe-visibility', ObserveVisibility);

Vue.use(VueSweetalert2, {
  toast: true,
  position: 'bottom-right',
});

Vue.use(Vue2Filters, {
  currency: {
    symbol: 'R$ ',
    thousandsSeparator: '.',
    decimalSeparator: ',',
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
